const StorageType = {
  AuthInfo: 'AUTH_INFO',
  Features: 'FEATURES',
};

export const setDataToLocalStorage = (key, data) => {
  if (data) {
    localStorage.setItem(key, JSON.stringify(data));
  } else {
    localStorage.removeItem(key);
  }
};

export const getDataFromLocalStorage = key => {
  const data = localStorage.getItem(key);
  if (data) {
    try {
      return JSON.parse(data);
    } catch (err) {
      setDataToLocalStorage(key);
    }
  }
};

export const setFeatures = featureList => {
  if (featureList) {
    localStorage.setItem(StorageType.Features, JSON.stringify(featureList));
  } else {
    localStorage.removeItem(StorageType.Features);
  }
};

export const getFeatures = () => {
  const data = localStorage.getItem(StorageType.Features);
  if (data) {
    try {
      return JSON.parse(data);
    } catch (err) {
      setFeatures();
    }
  }
};
